import { crearVariables } from "./crearVariables";
import { crearPosicionesApuesta } from "./crearPosicionesApuesta";
import { crearPosicionesUltimaApuesta} from "./crearPosicionesUltimaApuesta"
import { crearColeccionImagenesApuestasGanadoras } from "./crearColeccionImagenesApuestasGanadoras";

/**
 * Carga todos los assets del juego de la ruleta
 * @param {*} scene 
 */
export function creacionParametrosPrincipal(scene) {

  crearVariables(scene);
  crearPosicionesApuesta(scene);
  crearPosicionesUltimaApuesta(scene);
  //crearColeccionImagenesApuestasGanadoras(scene);

}